import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import InsertCommentIcon from '@material-ui/icons/InsertComment';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CrcDialog from '../../../modules/checkListGenerator/crcChecklist/crcChecklistAddRelevancePopUp';
import { createGenInfoRequest, createGenInfoRequestSave, panelIndexUpdate } from '../../../modules/checkListGenerator/store/actions/index';
import moment from 'moment';
import PreviewImage from '../../../assets/previewImage.png';
import Tooltip from '@material-ui/core/Tooltip';
import PreviewModal from '../../../components/modal/previewModal';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import { CommonConfig } from '../../../config/common-config';
import downloadImage from '../../../assets/downloadImage.png';
import axios from 'axios';
import buttonDisable from '../../disableField/buttonDisable';
import { userType } from '../../../config/usertypeValue';

const useStyles = makeStyles((theme) => ({
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    toggleCss: {
        marginLeft: '0',
        marginRight: '0',
    },
    chekListAddBtn: {
        marginLeft: '20px',
        borderColor: '#5a58b1',
        color: '#5a58b1',
        borderRadius: '5px',
        width: '100px',
        padding: '5px',
        background: 'transparent',
    },
    button: {
        margin: '10px 0px 5px !important',
        width: '155px',
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik !important',
    },
    checked: {},
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },

        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    relevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: '#3ccbcb',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
        fontFamily: 'Rubik',
    },

    irrelevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: '#db466b',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
        fontFamily: 'Rubik',
    },

    partrelevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: ' #FFC300',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
        fontFamily: 'Rubik',
    },
    btnFieldPositionRight: {
        position: 'absolute',
        right: '0',
        top: '12px',
    },
}));
function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}
export default function CrcGeneralInformation(props) {
    let tempValues = {};

    const classes = useStyles();
    const dispatch = useDispatch({});
    const [itecOpen, setItecOpen] = React.useState(false);
    const [relevanceCat, setRelevanceCat] = React.useState('');
    const [apiResponse, setApiResponse] = React.useState('');
    const [apiResponseBank, setApiResponseBank] = React.useState('');
    const [apithirdscreenvalues, setApithirdscreenvalues] = React.useState('');
    const [apiincomeTaxValues, setApiincomeTaxValues] = React.useState('');
    const [apitravelOutside, setApitravelOutside] = React.useState('');
    const [apiyesorNoType, setApiyesorNoType] = React.useState('');
    const [apidirectorCompany, setApidirectorCompany] = React.useState('');
    const [apiassetHome, setApiassetHome] = React.useState('');
    const [apiassetNature, setApiassetNature] = React.useState('');
    const [apiclient1, setApiclient1] = React.useState('');
    const [apiclient2, setApiclient2] = React.useState('');
    const [apiclient3, setApiclient3] = React.useState('');
    const [apiclient4, setApiclient4] = React.useState('');
    const [apiclient5, setApiclient5] = React.useState('');
    const [apiclient6, setApiclient6] = React.useState('');
    const [apiclient7, setApiclient7] = React.useState('');
    const [apiclient8, setApiclient8] = React.useState('');
    const [apiclient9, setApiclient9] = React.useState('');
    const [apiclient10, setApiclient10] = React.useState('');
    const [apilabelAdata, setApilabelAdata] = React.useState('');
    const [apilabelBdata, setApilabelBdata] = React.useState('');
    const [apilabelCdata, setApilabelCdata] = React.useState('');
    const [apilabelDdata, setApilabelDdata] = React.useState('');
    const [apilabelEdata, setApilabelEdata] = React.useState('');

    const [apiAddAdditionalQue, setApiAddAdditionalQue] = React.useState('');
    const [relevenceDispay, setRelevenceDispay] = useState('');
    const [category, setCategory] = React.useState('');
    const [remarks, setRemarks] = React.useState('');
    const [statusId, setStatusId] = React.useState('');
    const [visible, setVisible] = React.useState(false);
    const [downloadFile, setDownloadFile] = useState('');
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    const [handleOpen, setHandleOpen] = useState(false);

    const [checklist, setChecklist] = useState('');
    const checklistValues = checklist.checklistJson;
    const checklist1 = checklistValues && checklistValues.checklistL1;
    const [values, setValues] = React.useState({
        firstName: '',
        lastName: '',
        fatherNamePan: '',
        pan: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        country: '',
        pin: '',
        dob: '',
        mobileNo: '',
        emailaddress: '',
        passport: '',
        govIDType: '',
        govIDNumber: '',
        URLValue: '',
        radiodata: '',
        GSTIN: '',
        panFile: '',
        aadharFile: '',
        enrollmentFile: '',
        gstFile: '',
    });

    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;

    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[0].branchName;
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const stageId = useSelector((state) => state.serviceCheckListReducer.selectedStageId);
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);

    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
    };
    // const [open, setOpen] = React.useState(false);
    const createGenInfo = useSelector((state) => state.geninforeducer.creategeninfo);
    const statusIDResult = props.serviceIdValue;

    if (createGenInfo.serviceIdValue === statusIDResult) {
        tempValues = createGenInfo && createGenInfo.params;
    }
    const [showLoader, setShowLoader] = useState(false);
    const handleRelevence = (name, categoryValue, remarksValue) => {
        setCategory(categoryValue);
        setRemarks(remarksValue);
        setRelevanceCat(name);
        setTimeout(() => {
            setItecOpen(true);
        }, 1000);
    };
    const handleItecClose = () => {
        setTimeout(() => {
            setItecOpen(false);
        }, 1000);
    };

    const handleClose = () => {
        setHandleOpen(false);
    };

    const handleModalClose = () => {
        setVisible(false);
    };

    const handlePreviewModal = (file) => {
        setDownloadFile(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`);
        setShowBtnLoader(true);
        setTimeout(() => {
            setShowBtnLoader(false);
            setVisible(true);
        }, 1000);
    };

    const downloadCoreFile = (file) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`, {
                headers: {
                    Authorization: bearerToken,
                },
                responseType: 'blob',
            })

            .then((response) => {
                const link = document.createElement('a');
                link.href = response.config.url;
                link.setAttribute('download', response.config.url);
                link.click();
            });
    };

    useEffect(() => {
        setStatusId(props.statusId);
        setApiResponse(props.apiResponse.fields);
        setApiResponseBank(props.bankDetails);
        setApithirdscreenvalues(props.thirdscreenvalues);
        setApiincomeTaxValues(props.incomeTaxValues);
        setApitravelOutside(props.travelOutside);
        setApiyesorNoType(props.yesorNoType);
        setApidirectorCompany(props.directorCompany);
        setApiassetHome(props.assetHome);
        setApiassetNature(props.assetNature);
        setApiclient1(props.client1);
        setApiclient2(props.client2);
        setApiclient3(props.client3);
        setApiclient4(props.client4);
        setApiclient5(props.client5);
        setApiclient6(props.client6);
        setApiclient7(props.client7);
        setApiclient8(props.client8);
        setApiclient9(props.client9);
        setApiclient10(props.client10);
        setApilabelAdata(props.labelAdata);
        setApilabelBdata(props.labelBdata);
        setApilabelCdata(props.labelCdata);
        setApilabelDdata(props.labelDdata);
        setApilabelEdata(props.labelEdata);

        setApiAddAdditionalQue(props.addAdditionalQue);
        if (props.apiResponse.fields) {
            let iniVal = {
                firstName: apiResponse && apiResponse[0].response,
                firstnameRelevance: apiResponse && apiResponse[0].relevanceResponseCRC,
                firstnameRelevanceRemarks: apiResponse && apiResponse[0].relevanceRemarksCRC,

                lastName: apiResponse && apiResponse[1].response,
                lastnameRelevance: apiResponse && apiResponse[1].relevanceResponseCRC,
                lastnameRelevanceRemarks: apiResponse && apiResponse[1].relevanceRemarksCRC,

                fatherNamePan: apiResponse && apiResponse[2].response,
                fatherNamePanRelevance: apiResponse && apiResponse[2].relevanceResponseCRC,
                fatherNamePanRelevanceRemarks: apiResponse && apiResponse[2].relevanceRemarksCRC,

                pan: apiResponse && apiResponse[3].response,
                panRelevance: apiResponse && apiResponse[3].relevanceResponseCRC,
                panRelevanceRemarks: apiResponse && apiResponse[3].relevanceRemarksCRC,

                address1: apiResponse && apiResponse[4].response,
                address1Relevance: apiResponse && apiResponse[4].relevanceResponseCRC,
                address1RelevanceRemarks: apiResponse && apiResponse[4].relevanceRemarksCRC,

                address2: apiResponse && apiResponse[5].response,
                address2Relevance: apiResponse && apiResponse[5].relevanceResponseCRC,
                address2RelevanceRemarks: apiResponse && apiResponse[5].relevanceRemarksCRC,

                city: apiResponse && apiResponse[6].response,
                cityRelevance: apiResponse && apiResponse[6].relevanceResponseCRC,
                cityRelevanceRemarks: apiResponse && apiResponse[6].relevanceRemarksCRC,

                state: apiResponse && apiResponse[7].response,
                stateRelevance: apiResponse && apiResponse[7].relevanceResponseCRC,
                stateRelevanceRemarks: apiResponse && apiResponse[7].relevanceRemarksCRC,

                country: apiResponse && apiResponse[8].response,
                countryRelevance: apiResponse && apiResponse[8].relevanceResponseCRC,
                countryRelevanceRemarks: apiResponse && apiResponse[8].relevanceRemarksCRC,

                pin: apiResponse && apiResponse[9].response,
                pinRelevance: apiResponse && apiResponse[9].relevanceResponseCRC,
                pinRelevanceRemarks: apiResponse && apiResponse[9].relevanceRemarksCRC,

                dob: apiResponse && apiResponse[10].response,
                dobRelevance: apiResponse && apiResponse[10].relevanceResponseCRC,
                dobRelevanceRemarks: apiResponse && apiResponse[10].relevanceRemarksCRC,

                mobileNo: apiResponse && apiResponse[11].response,
                mobileNoRelevance: apiResponse && apiResponse[11].relevanceResponseCRC,
                mobileNoRelevanceRemarks: apiResponse && apiResponse[11].relevanceRemarksCRC,

                emailaddress: apiResponse && apiResponse[12].response,
                emailaddressRelevance: apiResponse && apiResponse[12].relevanceResponseCRC,
                emailaddressRelevanceRemarks: apiResponse && apiResponse[12].relevanceRemarksCRC,

                passport: apiResponse && apiResponse[13].response,
                passportRelevance: apiResponse && apiResponse[13].relevanceResponseCRC,
                passportRelevanceRemarks: apiResponse && apiResponse[13].relevanceRemarksCRC,

                govIDType: apiResponse && apiResponse[14].response,

                govIDNumber: apiResponse && apiResponse[15].response,
                govIDNumberRelevance: apiResponse && apiResponse[15].relevanceResponseCRC,
                govIDNumberRelevanceRemarks: apiResponse && apiResponse[15].relevanceRemarksCRC,

                URLValue: apiResponse && apiResponse[16].response,

                radiodata: apiResponse && apiResponse[17].response,

                GSTIN: apiResponse && apiResponse[18].response,
                gstinRelevance: apiResponse && apiResponse[18].relevanceResponseCRC,
                gstinRelevanceRemarks: apiResponse && apiResponse[18].relevanceRemarksCRC,
                panFile: apiResponse && apiResponse[19] && apiResponse[19].response,
                aadharFile: apiResponse && apiResponse[20] && apiResponse[20].response,
                enrollmentFile: apiResponse && apiResponse[21] && apiResponse[21].response,
                gstFile: apiResponse && apiResponse[22] && apiResponse[22].response,
            };
            setValues(iniVal);
        }
    }, [props]);

    const updateCRCRelevance = (category, remarks) => {
        // setShowLoader(true);
        setTimeout(() => {
            setItecOpen(false);
        }, 2000);
        const data = {
            firstName: apiResponse && apiResponse[0].response,
            firstnameRelevance: (tempValues && tempValues.firstnameRelevance) || (apiResponse && apiResponse[0].relevanceResponseCRC),
            firstnameRelevanceRemarks:
                (tempValues && tempValues.firstnameRelevanceRemarks) || (apiResponse && apiResponse[0].relevanceRemarksCRC) || '',

            lastName: apiResponse && apiResponse[1].response,
            lastnameRelevance: (tempValues && tempValues.lastnameRelevance) || (apiResponse && apiResponse[1].relevanceResponseCRC),
            lastnameRelevanceRemarks:
                (tempValues && tempValues.lastnameRelevanceRemarks) || (apiResponse && apiResponse[1].relevanceRemarksCRC) || '',

            fatherNamePan: apiResponse && apiResponse[2].response,
            fatherNamePanRelevance:
                (tempValues && tempValues.fatherNamePanRelevance) || (apiResponse && apiResponse[2].relevanceResponseCRC),
            fatherNamePanRelevanceRemarks:
                (tempValues && tempValues.fatherNamePanRelevanceRemarks) || (apiResponse && apiResponse[2].relevanceRemarksCRC) || '',

            pan: apiResponse && apiResponse[3].response,
            panRelevance: (tempValues && tempValues.panRelevance) || (apiResponse && apiResponse[3].relevanceResponseCRC),
            panRelevanceRemarks:
                (tempValues && tempValues.panRelevanceRemarks) || (apiResponse && apiResponse[3].relevanceRemarksCRC) || '',

            address1: apiResponse && apiResponse[4].response,
            address1Relevance: (tempValues && tempValues.address1Relevance) || (apiResponse && apiResponse[4].relevanceResponseCRC),
            address1RelevanceRemarks:
                (tempValues && tempValues.address1RelevanceRemarks) || (apiResponse && apiResponse[4].relevanceRemarksCRC) || '',

            address2: apiResponse && apiResponse[5].response,
            address2Relevance: (tempValues && tempValues.address2Relevance) || (apiResponse && apiResponse[5].relevanceResponseCRC),
            address2RelevanceRemarks:
                (tempValues && tempValues.address2RelevanceRemarks) || (apiResponse && apiResponse[5].relevanceRemarksCRC) || '',

            city: apiResponse && apiResponse[6].response,
            cityRelevance: (tempValues && tempValues.cityRelevance) || (apiResponse && apiResponse[6].relevanceResponseCRC),
            cityRelevanceRemarks:
                (tempValues && tempValues.cityRelevanceRemarks) || (apiResponse && apiResponse[6].relevanceRemarksCRC) || '',

            state: apiResponse && apiResponse[7].response,
            stateRelevance: (tempValues && tempValues.stateRelevance) || (apiResponse && apiResponse[7].relevanceResponseCRC),
            stateRelevanceRemarks:
                (tempValues && tempValues.stateRelevanceRemarks) || (apiResponse && apiResponse[7].relevanceRemarksCRC) || '',

            country: apiResponse && apiResponse[8].response,
            countryRelevance: (tempValues && tempValues.countryRelevance) || (apiResponse && apiResponse[8].relevanceResponseCRC),
            countryRelevanceRemarks:
                (tempValues && tempValues.countryRelevanceRemarks) || (apiResponse && apiResponse[8].relevanceRemarksCRC) || '',

            pin: apiResponse && apiResponse[9].response,
            pinRelevance: (tempValues && tempValues.pinRelevance) || (apiResponse && apiResponse[9].relevanceResponseCRC),
            pinRelevanceRemarks:
                (tempValues && tempValues.pinRelevanceRemarks) || (apiResponse && apiResponse[9].relevanceRemarksCRC) || '',

            dob: apiResponse && apiResponse[10].response,
            dobRelevance: (tempValues && tempValues.dobRelevance) || (apiResponse && apiResponse[10].relevanceResponseCRC),
            dobRelevanceRemarks:
                (tempValues && tempValues.dobRelevanceRemarks) || (apiResponse && apiResponse[10].relevanceRemarksCRC) || '',

            mobileNo: apiResponse && apiResponse[11].response,
            mobileNoRelevance: (tempValues && tempValues.mobileNoRelevance) || (apiResponse && apiResponse[11].relevanceResponseCRC),
            mobileNoRelevanceRemarks:
                (tempValues && tempValues.mobileNoRelevanceRemarks) || (apiResponse && apiResponse[11].relevanceRemarksCRC) || '',

            emailaddress: apiResponse && apiResponse[12].response,
            emailaddressRelevance:
                (tempValues && tempValues.emailaddressRelevance) || (apiResponse && apiResponse[12].relevanceResponseCRC),
            emailaddressRelevanceRemarks:
                (tempValues && tempValues.emailaddressRelevanceRemarks) || (apiResponse && apiResponse[12].relevanceRemarksCRC) || '',

            passport: apiResponse && apiResponse[13].response,
            passportRelevance: (tempValues && tempValues.passportRelevance) || (apiResponse && apiResponse[13].relevanceResponseCRC),
            passportRelevanceRemarks:
                (tempValues && tempValues.passportRelevanceRemarks) || (apiResponse && apiResponse[13].relevanceRemarksCRC) || '',

            govIDType: apiResponse && apiResponse[14].response,

            govIDNumber: apiResponse && apiResponse[15].response,
            govIDNumberRelevance: (tempValues && tempValues.govIDNumberRelevance) || (apiResponse && apiResponse[15].relevanceResponseCRC),
            govIDNumberRelevanceRemarks:
                (tempValues && tempValues.govIDNumberRelevanceRemarks) || (apiResponse && apiResponse[15].relevanceRemarksCRC) || '',

            URLValue: apiResponse && apiResponse[16].response,

            radiodata: apiResponse && apiResponse[17].response,

            GSTIN: apiResponse && apiResponse[18].response,
            gstinRelevance: (tempValues && tempValues.relevanceResponseCRC) || (apiResponse && apiResponse[18].relevanceResponseCRC),
            gstinRelevanceRemarks:
                (tempValues && tempValues.relevanceRemarksCRC) || (apiResponse && apiResponse[18].relevanceRemarksCRC) || '',
            panFile: apiResponse && apiResponse[19].response,
            aadharFile: apiResponse && apiResponse[20].response,
            enrollmentFile: apiResponse && apiResponse[21].response,
            gstFile: apiResponse && apiResponse[22].response,

            bankDetails: apiResponseBank,
            ...apithirdscreenvalues,
            ...apiincomeTaxValues,
            travelOutside: apitravelOutside,

            incomeTaxType: apiyesorNoType && apiyesorNoType.incomeTaxType,
            traveloutsideType: apiyesorNoType && apiyesorNoType.traveloutsideType,
            directorType: apiyesorNoType && apiyesorNoType.directorType,
            assetradio: apiyesorNoType && apiyesorNoType.assetradio,
            totalincomeradio: apiyesorNoType && apiyesorNoType.totalincomeradio,

            directorCompany: apidirectorCompany,
            assetHome: apiassetHome,
            assetNature: apiassetNature,
            client1: apiclient1,
            client2: apiclient2,
            client3: apiclient3,
            client4: apiclient4,
            client5: apiclient5,
            client6: apiclient6,
            client7: apiclient7,
            client8: apiclient8,
            client9: apiclient9,
            client10: apiclient10,
            labelAdata: apilabelAdata,
            labelBdata: apilabelBdata,
            labelCdata: apilabelCdata,
            labelDdata: apilabelDdata,
            labelEdata: apilabelEdata,
            additionalQue: apiAddAdditionalQue,
        };

        if (relevanceCat === 'firstname') {
            data.firstnameRelevance = category;
            data.firstnameRelevanceRemarks = remarks;
        }
        if (relevanceCat === 'lastname') {
            data.lastnameRelevance = category;
            data.lastnameRelevanceRemarks = remarks;
        }
        if (relevanceCat === 'fatherNamePan') {
            data.fatherNamePanRelevance = category;
            data.fatherNamePanRelevanceRemarks = remarks;
        }
        if (relevanceCat === 'pan') {
            data.panRelevance = category;
            data.panRelevanceRemarks = remarks;
        }
        if (relevanceCat === 'address1') {
            data.address1Relevance = category;
            data.address1RelevanceRemarks = remarks;
        }
        if (relevanceCat === 'address2') {
            data.address2Relevance = category;
            data.address2RelevanceRemarks = remarks;
        }
        if (relevanceCat === 'city') {
            data.cityRelevance = category;
            data.cityRelevanceRemarks = remarks;
        }
        if (relevanceCat === 'state') {
            data.stateRelevance = category;
            data.stateRelevanceRemarks = remarks;
        }
        if (relevanceCat === 'country') {
            data.countryRelevance = category;
            data.countryRelevanceRemarks = remarks;
        }
        if (relevanceCat === 'pin') {
            data.pinRelevance = category;
            data.pinRelevanceRemarks = remarks;
        }
        if (relevanceCat === 'dob') {
            data.dobRelevance = category;
            data.dobRelevanceRemarks = remarks;
        }
        if (relevanceCat === 'mobileNo') {
            data.mobileNoRelevance = category;
            data.mobileNoRelevanceRemarks = remarks;
        }
        if (relevanceCat === 'emailaddress') {
            data.emailaddressRelevance = category;
            data.emailaddressRelevanceRemarks = remarks;
        }
        if (relevanceCat === 'passport') {
            data.passportRelevance = category;
            data.passportRelevanceRemarks = remarks;
        }
        if (relevanceCat === 'GSTIN') {
            data.gstinRelevance = category;
            data.gstinRelevanceRemarks = remarks;
        }

        if (relevanceCat === 'govIDNumber') {
            data.govIDNumberRelevance = category;
            data.govIDNumberRelevanceRemarks = remarks;
        }

        // console.log('GeneralInfo =>>>>>>> data', data);

        props.updateApiData(data);
        setRelevenceDispay(data);
        dispatch(createGenInfoRequest({ params: data, serviceIdValue: statusIDResult }));
        dispatch(panelIndexUpdate({ panelID: 'panel1' }));
        dispatch(createGenInfoRequestSave({ params: data, bearerToken, serviceIdValue: statusIDResult, usertype, imcNameSelected }));
        props.onChange(data);
        props.rerenderApi(!props.rerender);
    };
    return (
        <>
            {showLoader ? <LoaderPopUp showLoader={showLoader} /> : null}

            <Grid container spacing={3} className="main-container">
                {apiResponse && apiResponse[0].response === "NaN" ? "" :
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="first-name">First Name</InputLabel>

                            <Input disabled className={classes.bottomLine} id="standard-adornment-amount" value={values.firstName} />
                            <div>
                                <Typography className={classes.bottomLine}>
                                    {((apiResponse && apiResponse[0].relevanceResponseCRC) || relevenceDispay.firstnameRelevance) ===
                                        'Relevant' ? (
                                            <div className={classes.relevanceIndicator}>
                                                {/* {(apiResponse && apiResponse[0].relevanceRemarksCRC) || relevenceDispay.firstnameRelevanceRemarks}{' '} */}
                                                {(apiResponse && apiResponse[0].relevanceRemarksCRC)}{' '}

                                            </div>
                                        ) : ((apiResponse && apiResponse[0].relevanceResponseCRC) || relevenceDispay.firstnameRelevance) ===
                                            'Irrelavant' ? (
                                                <div className={classes.irrelevanceIndicator}>
                                                    {/* {(apiResponse && apiResponse[0].relevanceRemarksCRC) || relevenceDispay.firstnameRelevanceRemarks} */}
                                                    {(apiResponse && apiResponse[0].relevanceRemarksCRC)}

                                                </div>
                                            ) : ((apiResponse && apiResponse[0].relevanceResponseCRC) || relevenceDispay.firstnameRelevance) ===
                                                'Paritially Relevant' ? (
                                                    <div className={classes.partrelevanceIndicator}>
                                                        {/* {(apiResponse && apiResponse[0].relevanceRemarksCRC) || relevenceDispay.firstnameRelevanceRemarks} */}
                                                        {(apiResponse && apiResponse[0].relevanceRemarksCRC)}

                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                </Typography>
                            </div>
                            {stageId === 10 && usertype === 'EM' ? (
                                ''
                            ) : stageId === 8 && apiResponse && apiResponse[0].relevanceResponseCRC === 'Relevant' ? (
                                ''
                            ) : (
                                        <Button
                                            // disabled={usertype === 'EM' ? 'disabled' : ''}
                                            variant="outlined"
                                            color="primary"
                                            size="small"
                                            // onClick={handleClickOpen}
                                            className={classes.button}
                                            startIcon={<InsertCommentIcon />}
                                            onClick={() =>
                                                handleRelevence(
                                                    'firstname',
                                                    relevenceDispay.firstnameRelevance || (apiResponse && apiResponse[0].relevanceResponseCRC),
                                                    (apiResponse && apiResponse[0].relevanceRemarksCRC) || relevenceDispay.firstnameRelevanceRemarks
                                                )
                                            }
                                            disabled={buttonDisable(stageId, userType.value)}
                                        >
                                            Add Relevance
                            </Button>
                                    )}
                        </FormControl>
                    </Grid>
                }
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        {apiResponse && apiResponse[0].response === "NaN" ?
                            <InputLabel htmlFor="last-name">Corporate Name</InputLabel>
                            :
                            <InputLabel htmlFor="last-name">Last Name</InputLabel>
                        }
                        <Input
                            disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.lastName}
                            onChange={handleChange('lastName')}
                        />
                        <div>
                            <Typography className={classes.bottomLine}>
                                {((apiResponse && apiResponse[1].relevanceResponseCRC) || relevenceDispay.lastnameRelevance) ===
                                    'Relevant' ? (
                                        <div className={classes.relevanceIndicator}>
                                            {/* {(apiResponse && apiResponse[1].relevanceRemarksCRC) || relevenceDispay.lastnameRelevanceRemarks}{' '} */}
                                            {(apiResponse && apiResponse[1].relevanceRemarksCRC)}{' '}

                                        </div>
                                    ) : ((apiResponse && apiResponse[1].relevanceResponseCRC) || relevenceDispay.lastnameRelevance) ===
                                        'Irrelavant' ? (
                                            <div className={classes.irrelevanceIndicator}>
                                                {/* {(apiResponse && apiResponse[1].relevanceRemarksCRC) || relevenceDispay.lastnameRelevanceRemarks} */}
                                                {(apiResponse && apiResponse[1].relevanceRemarksCRC)}

                                            </div>
                                        ) : ((apiResponse && apiResponse[1].relevanceResponseCRC) || relevenceDispay.lastnameRelevance) ===
                                            'Paritially Relevant' ? (
                                                <div className={classes.partrelevanceIndicator}>
                                                    {/* {(apiResponse && apiResponse[1].relevanceRemarksCRC) || relevenceDispay.lastnameRelevanceRemarks} */}
                                                    {(apiResponse && apiResponse[1].relevanceRemarksCRC)}

                                                </div>
                                            ) : (
                                                ''
                                            )}
                            </Typography>
                        </div>
                        {stageId === 10 && usertype === 'EM' ? (
                            ''
                        ) : stageId === 8 && apiResponse && apiResponse[1].relevanceResponseCRC === 'Relevant' ? (
                            ''
                        ) : (
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        startIcon={<InsertCommentIcon />}
                                        onClick={() =>
                                            handleRelevence(
                                                'lastname',
                                                relevenceDispay.lastnameRelevance || (apiResponse && apiResponse[1].relevanceResponseCRC),
                                                (apiResponse && apiResponse[1].relevanceRemarksCRC) || relevenceDispay.lastnameRelevanceRemarks
                                            )
                                        }
                                        disabled={buttonDisable(stageId, userType.value)}
                                    >
                                        Add Relevance
                            </Button>
                                )}
                    </FormControl>
                </Grid>
                {apiResponse && apiResponse[0].response === "NaN" ? "" :
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="fathers-name">Father's Name</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="standard-adornment-amount"
                                value={values.fatherNamePan}
                                onChange={handleChange('fatherNamePan')}
                            />

                            <div>
                                <Typography className={classes.bottomLine}>
                                    {((apiResponse && apiResponse[2].relevanceResponseCRC) || relevenceDispay.fatherNamePanRelevance) ===
                                        'Relevant' ? (
                                            <div className={classes.relevanceIndicator}>
                                                {
                                                    // (apiResponse && apiResponse[2].relevanceRemarksCRC) || relevenceDispay.fatherNamePanRelevanceRemarks}{' '}
                                                    (apiResponse && apiResponse[2].relevanceRemarksCRC)}{' '}

                                            </div>
                                        ) : ((apiResponse && apiResponse[2].relevanceResponseCRC) || relevenceDispay.fatherNamePanRelevance) ===
                                            'Irrelavant' ? (
                                                <div className={classes.irrelevanceIndicator}>
                                                    {
                                                        // (apiResponse && apiResponse[2].relevanceRemarksCRC) || relevenceDispay.fatherNamePanRelevanceRemarks}
                                                        (apiResponse && apiResponse[2].relevanceRemarksCRC)}

                                                </div>
                                            ) : ((apiResponse && apiResponse[2].relevanceResponseCRC) || relevenceDispay.fatherNamePanRelevance) ===
                                                'Paritially Relevant' ? (
                                                    <div className={classes.partrelevanceIndicator}>
                                                        {
                                                            // (apiResponse && apiResponse[2].relevanceRemarksCRC) || relevenceDispay.fatherNamePanRelevanceRemarks}
                                                            (apiResponse && apiResponse[2].relevanceRemarksCRC)}

                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                </Typography>
                            </div>
                            {stageId === 10 && usertype === 'EM' ? (
                                ''
                            ) : stageId === 8 && apiResponse && apiResponse[2].relevanceResponseCRC === 'Relevant' ? (
                                ''
                            ) : (
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            size="small"
                                            className={classes.button}
                                            startIcon={<InsertCommentIcon />}
                                            onClick={() =>
                                                handleRelevence(
                                                    'fatherNamePan',
                                                    relevenceDispay.fatherNamePanRelevance || (apiResponse && apiResponse[2].relevanceResponseCRC),
                                                    (apiResponse && apiResponse[2].relevanceRemarksCRC) || relevenceDispay.fatherNamePanRelevanceRemarks
                                                )
                                            }
                                            disabled={buttonDisable(stageId, userType.value)}
                                        >
                                            Add Relevance
                            </Button>
                                    )}
                        </FormControl>
                    </Grid>
                }
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="pan">PAN</InputLabel>
                        <Input
                            disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.pan}
                            onChange={handleChange('pan')}
                        />
                        <div className={classes.btnFieldPositionRight}>
                            {values.panFile ? (
                                <span>
                                    <span style={{ marginRight: '7px' }}>
                                        {values.panFile.substring(values.panFile.lastIndexOf('/') + 1).substring(0, 15)}
                                        {values.panFile.substring(values.panFile.lastIndexOf('/') + 1).length > 15 ? '...' : ''}
                                    </span>
                                    <span onClick={() => handlePreviewModal(values.panFile)}>
                                        <Tooltip title="Preview">
                                            <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                        </Tooltip>
                                    </span>
                                    <span onClick={() => downloadCoreFile(values.panFile)}>
                                        <Tooltip title="Download">
                                            <img src={downloadImage} alt="downloadImage" className="downlaodImg downloadImgTop" />
                                        </Tooltip>
                                    </span>
                                </span>
                            ) : null}
                        </div>
                        <div>
                            <Typography className={classes.bottomLine}>
                                {((apiResponse && apiResponse[3].relevanceResponseCRC) || relevenceDispay.panRelevance) === 'Relevant' ? (
                                    <div className={classes.relevanceIndicator}>
                                        {/* {(apiResponse && apiResponse[3].relevanceRemarksCRC) || relevenceDispay.panRelevanceRemarks}{' '} */}
                                        {(apiResponse && apiResponse[3].relevanceRemarksCRC)}{' '}

                                    </div>
                                ) : ((apiResponse && apiResponse[3].relevanceResponseCRC) || relevenceDispay.panRelevance) ===
                                    'Irrelavant' ? (
                                            <div className={classes.irrelevanceIndicator}>
                                                {/* {(apiResponse && apiResponse[3].relevanceRemarksCRC) || relevenceDispay.panRelevanceRemarks} */}
                                                {(apiResponse && apiResponse[3].relevanceRemarksCRC)}

                                            </div>
                                        ) : ((apiResponse && apiResponse[3].relevanceResponseCRC) || relevenceDispay.panRelevance) ===
                                            'Paritially Relevant' ? (
                                                <div className={classes.partrelevanceIndicator}>
                                                    {/* {(apiResponse && apiResponse[3].relevanceRemarksCRC) || relevenceDispay.panRelevanceRemarks} */}
                                                    {(apiResponse && apiResponse[3].relevanceRemarksCRC)}

                                                </div>
                                            ) : (
                                                ''
                                            )}
                            </Typography>
                        </div>
                        {stageId === 10 && usertype === 'EM' ? (
                            ''
                        ) : stageId === 8 && apiResponse && apiResponse[3].relevanceResponseCRC === 'Relevant' ? (
                            ''
                        ) : (
                                    <Button
                                        // disabled={usertype === 'EM' ? 'disabled' : ''}
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        startIcon={<InsertCommentIcon />}
                                        onClick={() =>
                                            handleRelevence(
                                                'pan',
                                                relevenceDispay.panRelevance || (apiResponse && apiResponse[3].relevanceResponseCRC),
                                                (apiResponse && apiResponse[3].relevanceRemarksCRC) || relevenceDispay.panRelevanceRemarks
                                            )
                                        }
                                        disabled={buttonDisable(stageId, userType.value)}
                                    >
                                        Add Relevance
                            </Button>
                                )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="Address-Line-1">Address Line 1</InputLabel>
                        <Input
                            disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.address1}
                            onChange={handleChange('address1')}
                        />
                        <div>
                            <Typography className={classes.bottomLine}>
                                {((apiResponse && apiResponse[4].relevanceResponseCRC) || relevenceDispay.address1Relevance) ===
                                    'Relevant' ? (
                                        <div className={classes.relevanceIndicator}>
                                            {/* {((apiResponse && apiResponse[4].relevanceRemarksCRC) || relevenceDispay.address1RelevanceRemarks)}{' '} */}
                                            {((apiResponse && apiResponse[4].relevanceRemarksCRC))}{' '}

                                        </div>
                                    ) : ((apiResponse && apiResponse[4].relevanceResponseCRC) || relevenceDispay.address1Relevance) ===
                                        'Irrelavant' ? (
                                            <div className={classes.irrelevanceIndicator}>
                                                {/* {((apiResponse && apiResponse[4].relevanceRemarksCRC) || relevenceDispay.address1RelevanceRemarks)} */}
                                                {((apiResponse && apiResponse[4].relevanceRemarksCRC))}

                                            </div>
                                        ) : ((apiResponse && apiResponse[4].relevanceResponseCRC) || relevenceDispay.address1Relevance) ===
                                            'Paritially Relevant' ? (
                                                <div className={classes.partrelevanceIndicator}>
                                                    {/* {((apiResponse && apiResponse[4].relevanceRemarksCRC) || relevenceDispay.address1RelevanceRemarks)} */}
                                                    {((apiResponse && apiResponse[4].relevanceRemarksCRC))}

                                                </div>
                                            ) : (
                                                ''
                                            )}
                            </Typography>
                        </div>
                        {stageId === 10 && usertype === 'EM' ? (
                            ''
                        ) : stageId === 8 && apiResponse && apiResponse[4].relevanceResponseCRC === 'Relevant' ? (
                            ''
                        ) : (
                                    <Button
                                        // disabled={usertype === 'EM' ? 'disabled' : ''}
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        startIcon={<InsertCommentIcon />}
                                        onClick={() =>
                                            handleRelevence(
                                                'address1',
                                                relevenceDispay.address1Relevance || (apiResponse && apiResponse[4].relevanceResponseCRC),
                                                (apiResponse && apiResponse[4].relevanceRemarksCRC) || relevenceDispay.address1RelevanceRemarks
                                            )
                                        }
                                        disabled={buttonDisable(stageId, userType.value)}
                                    >
                                        Add Relevance
                            </Button>
                                )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="Address-Line-2">Address Line 2</InputLabel>
                        <Input
                            disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.address2}
                            onChange={handleChange('address2')}
                        />
                        <div>
                            <Typography className={classes.bottomLine}>
                                {(apiResponse && apiResponse[5].relevanceResponseCRC || relevenceDispay.address2Relevance) ===
                                    'Relevant' ? (
                                        <div className={classes.relevanceIndicator}>
                                            {/* {(apiResponse && apiResponse[5].relevanceRemarksCRC || relevenceDispay.address2RelevanceRemarks)}{' '} */}
                                            {apiResponse && apiResponse[5].relevanceRemarksCRC}{' '}

                                        </div>
                                    ) : (apiResponse && apiResponse[5].relevanceResponseCRC || relevenceDispay.address2Relevance) ===
                                        'Irrelavant' ? (
                                            <div className={classes.irrelevanceIndicator}>
                                                {/* {(apiResponse && apiResponse[5].relevanceRemarksCRC || relevenceDispay.address2RelevanceRemarks)} */}
                                                {apiResponse && apiResponse[5].relevanceRemarksCRC}

                                            </div>
                                        ) : ((apiResponse && apiResponse[5].relevanceResponseCRC) || relevenceDispay.address2Relevance) ===
                                            'Paritially Relevant' ? (
                                                <div className={classes.partrelevanceIndicator}>
                                                    {apiResponse && apiResponse[5].relevanceRemarksCRC || relevenceDispay.address2RelevanceRemarks}
                                                </div>
                                            ) : (
                                                ''
                                            )}
                            </Typography>
                        </div>
                        {stageId === 10 && usertype === 'EM' ? (
                            ''
                        ) : stageId === 8 && apiResponse && apiResponse[5].relevanceResponseCRC === 'Relevant' ? (
                            ''
                        ) : (
                                    <Button
                                        // disabled={usertype === 'EM' ? 'disabled' : ''}
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        startIcon={<InsertCommentIcon />}
                                        onClick={() =>
                                            handleRelevence(
                                                'address2',
                                                relevenceDispay.address2Relevance || (apiResponse && apiResponse[5].relevanceResponseCRC),
                                                (apiResponse && apiResponse[5].relevanceRemarksCRC) || relevenceDispay.address2RelevanceRemarks
                                            )
                                        }
                                        disabled={buttonDisable(stageId, userType.value)}
                                    >
                                        Add Relevance
                            </Button>
                                )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="country">Country</InputLabel>
                        <Input
                            disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.country}
                            onChange={handleChange('country')}
                        />
                        <div>
                            <Typography className={classes.bottomLine}>
                                {((apiResponse && apiResponse[8].relevanceResponseCRC) || relevenceDispay.countryRelevance) ===
                                    'Relevant' ? (
                                        <div className={classes.relevanceIndicator}>
                                            {/* {(apiResponse && apiResponse[8].relevanceRemarksCRC) || relevenceDispay.countryRelevanceRemarks}{' '} */}
                                            {(apiResponse && apiResponse[8].relevanceRemarksCRC)}{' '}

                                        </div>
                                    ) : ((apiResponse && apiResponse[8].relevanceResponseCRC) || relevenceDispay.countryRelevance) ===
                                        'Irrelavant' ? (
                                            <div className={classes.irrelevanceIndicator}>
                                                {/* {(apiResponse && apiResponse[8].relevanceRemarksCRC) || relevenceDispay.countryRelevanceRemarks} */}
                                                {(apiResponse && apiResponse[8].relevanceRemarksCRC)}

                                            </div>
                                        ) : ((apiResponse && apiResponse[8].relevanceResponseCRC) || relevenceDispay.countryRelevance) ===
                                            'Paritially Relevant' ? (
                                                <div className={classes.partrelevanceIndicator}>
                                                    {/* {(apiResponse && apiResponse[8].relevanceRemarksCRC) || relevenceDispay.countryRelevanceRemarks} */}
                                                    {(apiResponse && apiResponse[8].relevanceRemarksCRC)}

                                                </div>
                                            ) : (
                                                ''
                                            )}
                            </Typography>
                        </div>
                        {stageId === 10 && usertype === 'EM' ? (
                            ''
                        ) : stageId === 8 && apiResponse && apiResponse[8].relevanceResponseCRC === 'Relevant' ? (
                            ''
                        ) : (
                                    <Button
                                        // disabled={usertype === 'EM' ? 'disabled' : ''}
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        startIcon={<InsertCommentIcon />}
                                        onClick={() =>
                                            handleRelevence(
                                                'country',
                                                relevenceDispay.countryRelevance || (apiResponse && apiResponse[8].relevanceResponseCRC),
                                                (apiResponse && apiResponse[8].relevanceRemarksCRC) || relevenceDispay.countryRelevanceRemarks
                                            )
                                        }
                                        disabled={buttonDisable(stageId, userType.value)}
                                    >
                                        Add Relevance
                            </Button>
                                )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="state">State</InputLabel>
                        <Input
                            disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.state}
                            onChange={handleChange('state')}
                        />
                        <div>
                            <Typography className={classes.bottomLine}>
                                {((apiResponse && apiResponse[7].relevanceResponseCRC) || relevenceDispay.stateRelevance) === 'Relevant' ? (
                                    <div className={classes.relevanceIndicator}>
                                        {/* {(apiResponse && apiResponse[7].relevanceRemarksCRC) || relevenceDispay.stateRelevanceRemarks}{' '} */}
                                        {(apiResponse && apiResponse[7].relevanceRemarksCRC)}{' '}

                                    </div>
                                ) : ((apiResponse && apiResponse[7].relevanceResponseCRC) || relevenceDispay.stateRelevance) ===
                                    'Irrelavant' ? (
                                            <div className={classes.irrelevanceIndicator}>
                                                {/* {(apiResponse && apiResponse[7].relevanceRemarksCRC) || relevenceDispay.stateRelevanceRemarks} */}
                                                {(apiResponse && apiResponse[7].relevanceRemarksCRC)}

                                            </div>
                                        ) : ((apiResponse && apiResponse[7].relevanceResponseCRC) || relevenceDispay.stateRelevance) ===
                                            'Paritially Relevant' ? (
                                                <div className={classes.partrelevanceIndicator}>
                                                    {/* {(apiResponse && apiResponse[7].relevanceRemarksCRC) || relevenceDispay.stateRelevanceRemarks} */}
                                                    {(apiResponse && apiResponse[7].relevanceRemarksCRC)}

                                                </div>
                                            ) : (
                                                ''
                                            )}
                            </Typography>
                        </div>
                        {stageId === 10 && usertype === 'EM' ? (
                            ''
                        ) : stageId === 8 && apiResponse && apiResponse[7].relevanceResponseCRC === 'Relevant' ? (
                            ''
                        ) : (
                                    <Button
                                        // disabled={usertype === 'EM' ? 'disabled' : ''}
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        startIcon={<InsertCommentIcon />}
                                        onClick={() =>
                                            handleRelevence(
                                                'state',
                                                relevenceDispay.stateRelevance || (apiResponse && apiResponse[7].relevanceResponseCRC),
                                                (apiResponse && apiResponse[7].relevanceRemarksCRC) || relevenceDispay.stateRelevanceRemarks
                                            )
                                        }
                                        disabled={buttonDisable(stageId, userType.value)}
                                    >
                                        Add Relevance
                            </Button>
                                )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="city">City</InputLabel>
                        <Input
                            disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.city}
                            onChange={handleChange('city')}
                        />
                        <div>
                            <Typography className={classes.bottomLine}>
                                {((apiResponse && apiResponse[6].relevanceResponseCRC) || relevenceDispay.cityRelevance) === 'Relevant' ? (
                                    <div className={classes.relevanceIndicator}>
                                        {/* {(apiResponse && apiResponse[6].relevanceRemarksCRC) || relevenceDispay.cityRelevanceRemarks}{' '} */}
                                        {(apiResponse && apiResponse[6].relevanceRemarksCRC)}{' '}

                                    </div>
                                ) : ((apiResponse && apiResponse[6].relevanceResponseCRC) || relevenceDispay.cityRelevance) ===
                                    'Irrelavant' ? (
                                            <div className={classes.irrelevanceIndicator}>
                                                {/* {(apiResponse && apiResponse[6].relevanceRemarksCRC) || relevenceDispay.cityRelevanceRemarks} */}
                                                {(apiResponse && apiResponse[6].relevanceRemarksCRC)}

                                            </div>
                                        ) : ((apiResponse && apiResponse[6].relevanceResponseCRC) || relevenceDispay.cityRelevance) ===
                                            'Paritially Relevant' ? (
                                                <div className={classes.partrelevanceIndicator}>
                                                    {/* {(apiResponse && apiResponse[6].relevanceRemarksCRC) || relevenceDispay.cityRelevanceRemarks} */}
                                                    {(apiResponse && apiResponse[6].relevanceRemarksCRC)}

                                                </div>
                                            ) : (
                                                ''
                                            )}
                            </Typography>
                        </div>
                        {stageId === 10 && usertype === 'EM' ? (
                            ''
                        ) : stageId === 8 && apiResponse && apiResponse[6].relevanceResponseCRC === 'Relevant' ? (
                            ''
                        ) : (
                                    <Button
                                        // disabled={usertype === 'EM' ? 'disabled' : ''}
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        startIcon={<InsertCommentIcon />}
                                        onClick={() =>
                                            handleRelevence(
                                                'city',
                                                relevenceDispay.cityRelevance || (apiResponse && apiResponse[6].relevanceResponseCRC),
                                                (apiResponse && apiResponse[6].relevanceRemarksCRC) || relevenceDispay.cityRelevanceRemarks
                                            )
                                        }
                                        disabled={buttonDisable(stageId, userType.value)}
                                    >
                                        Add Relevance
                            </Button>
                                )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="pin">Pin</InputLabel>
                        <Input
                            disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.pin}
                        // onChange={handleChange('pin')}
                        />
                        <div>
                            <Typography className={classes.bottomLine}>
                                {((apiResponse && apiResponse[9].relevanceResponseCRC) || relevenceDispay.pinRelevance) === 'Relevant' ? (
                                    <div className={classes.relevanceIndicator}>
                                        {/* {(apiResponse && apiResponse[9].relevanceRemarksCRC) || relevenceDispay.pinRelevanceRemarks}{' '} */}
                                        {(apiResponse && apiResponse[9].relevanceRemarksCRC)}{' '}

                                    </div>
                                ) : ((apiResponse && apiResponse[9].relevanceResponseCRC) || relevenceDispay.pinRelevance) ===
                                    'Irrelavant' ? (
                                            <div className={classes.irrelevanceIndicator}>
                                                {/* {(apiResponse && apiResponse[9].relevanceRemarksCRC) || relevenceDispay.pinRelevanceRemarks} */}
                                                {(apiResponse && apiResponse[9].relevanceRemarksCRC)}

                                            </div>
                                        ) : ((apiResponse && apiResponse[9].relevanceResponseCRC) || relevenceDispay.pinRelevance) ===
                                            'Paritially Relevant' ? (
                                                <div className={classes.partrelevanceIndicator}>
                                                    {/* {(apiResponse && apiResponse[9].relevanceRemarksCRC) || relevenceDispay.pinRelevanceRemarks} */}
                                                    {(apiResponse && apiResponse[9].relevanceRemarksCRC)}

                                                </div>
                                            ) : (
                                                ''
                                            )}
                            </Typography>
                        </div>
                        {stageId === 10 && usertype === 'EM' ? (
                            ''
                        ) : stageId === 8 && apiResponse && apiResponse[9].relevanceResponseCRC === 'Relevant' ? (
                            ''
                        ) : (
                                    <Button
                                        // disabled={usertype === 'EM' ? 'disabled' : ''}
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        startIcon={<InsertCommentIcon />}
                                        onClick={() =>
                                            handleRelevence(
                                                'pin',
                                                relevenceDispay.pinRelevance || (apiResponse && apiResponse[9].relevanceResponseCRC),
                                                (apiResponse && apiResponse[9].relevanceRemarksCRC) || relevenceDispay.pinRelevanceRemarks
                                            )
                                        }
                                        disabled={buttonDisable(stageId, userType.value)}
                                    >
                                        Add Relevance
                            </Button>
                                )}
                    </FormControl>
                </Grid>
                {apiResponse && apiResponse[0].response === "NaN" ? "" :
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="dob">DOB</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="standard-adornment-amount"
                                value={moment(values.dob).format('DD-MM-YYYY')}
                            // onChange={handleChange('dob')}
                            />
                            <div>
                                <Typography className={classes.bottomLine}>
                                    {((apiResponse && apiResponse[10].relevanceResponseCRC) || relevenceDispay.dobRelevance) === 'Relevant' ? (
                                        <div className={classes.relevanceIndicator}>
                                            {/* {(apiResponse && apiResponse[10].relevanceRemarksCRC) || relevenceDispay.dobRelevanceRemarks}{' '} */}
                                            {(apiResponse && apiResponse[10].relevanceRemarksCRC)}{' '}

                                        </div>
                                    ) : ((apiResponse && apiResponse[10].relevanceResponseCRC) || relevenceDispay.dobRelevance) ===
                                        'Irrelavant' ? (
                                                <div className={classes.irrelevanceIndicator}>
                                                    {/* {(apiResponse && apiResponse[10].relevanceRemarksCRC) || relevenceDispay.dobRelevanceRemarks} */}
                                                    {(apiResponse && apiResponse[10].relevanceRemarksCRC)}

                                                </div>
                                            ) : ((apiResponse && apiResponse[10].relevanceResponseCRC) || relevenceDispay.dobRelevance) ===
                                                'Paritially Relevant' ? (
                                                    <div className={classes.partrelevanceIndicator}>
                                                        {/* {(apiResponse && apiResponse[10].relevanceRemarksCRC) || relevenceDispay.dobRelevanceRemarks} */}
                                                        {(apiResponse && apiResponse[10].relevanceRemarksCRC)}

                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                </Typography>
                            </div>
                            {stageId === 10 && usertype === 'EM' ? (
                                ''
                            ) : stageId === 8 && apiResponse && apiResponse[10].relevanceResponseCRC === 'Relevant' ? (
                                ''
                            ) : (
                                        <Button
                                            // disabled={usertype === 'EM' ? 'disabled' : ''}
                                            variant="outlined"
                                            color="primary"
                                            size="small"
                                            className={classes.button}
                                            startIcon={<InsertCommentIcon />}
                                            onClick={() =>
                                                handleRelevence(
                                                    'dob',
                                                    relevenceDispay.dobRelevance || (apiResponse && apiResponse[10].relevanceResponseCRC),
                                                    (apiResponse && apiResponse[10].relevanceRemarksCRC) || relevenceDispay.dobRelevanceRemarks
                                                )
                                            }
                                            disabled={buttonDisable(stageId, userType.value)}
                                        >
                                            Add Relevance
                            </Button>
                                    )}
                        </FormControl>
                    </Grid>
                }
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="mobile-number">Mobile Number</InputLabel>
                        <Input
                            disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.mobileNo}
                        // onChange={handleChange('mobileNo')}
                        />
                        <div>
                            <Typography className={classes.bottomLine}>
                                {((apiResponse && apiResponse[11].relevanceResponseCRC) || relevenceDispay.mobileNoRelevance) ===
                                    'Relevant' ? (
                                        <div className={classes.relevanceIndicator}>
                                            {/* {(apiResponse && apiResponse[11].relevanceRemarksCRC) || relevenceDispay.mobileNoRelevanceRemarks}{' '} */}
                                            {(apiResponse && apiResponse[11].relevanceRemarksCRC)}{' '}

                                        </div>
                                    ) : ((apiResponse && apiResponse[11].relevanceResponseCRC) || relevenceDispay.mobileNoRelevance) ===
                                        'Irrelavant' ? (
                                            <div className={classes.irrelevanceIndicator}>
                                                {/* {(apiResponse && apiResponse[11].relevanceRemarksCRC) || relevenceDispay.mobileNoRelevanceRemarks} */}
                                                {(apiResponse && apiResponse[11].relevanceRemarksCRC)}

                                            </div>
                                        ) : ((apiResponse && apiResponse[11].relevanceResponseCRC) || relevenceDispay.mobileNoRelevance) ===
                                            'Paritially Relevant' ? (
                                                <div className={classes.partrelevanceIndicator}>
                                                    {/* {(apiResponse && apiResponse[11].relevanceRemarksCRC) || relevenceDispay.mobileNoRelevanceRemarks} */}
                                                    {(apiResponse && apiResponse[11].relevanceRemarksCRC)}

                                                </div>
                                            ) : (
                                                ''
                                            )}
                            </Typography>
                        </div>
                        {stageId === 10 && usertype === 'EM' ? (
                            ''
                        ) : stageId === 8 && apiResponse && apiResponse[11].relevanceResponseCRC === 'Relevant' ? (
                            ''
                        ) : (
                                    <Button
                                        // disabled={usertype === 'EM' ? 'disabled' : ''}
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        startIcon={<InsertCommentIcon />}
                                        onClick={() =>
                                            handleRelevence(
                                                'mobileNo',
                                                relevenceDispay.mobileNoRelevance || (apiResponse && apiResponse[11].relevanceResponseCRC),
                                                (apiResponse && apiResponse[11].relevanceRemarksCRC) || relevenceDispay.mobileNoRelevanceRemarks
                                            )
                                        }
                                        disabled={buttonDisable(stageId, userType.value)}
                                    >
                                        Add Relevance
                            </Button>
                                )}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="email-address">Email Address</InputLabel>
                        <Input
                            disabled
                            className={classes.bottomLine}
                            id="standard-adornment-amount"
                            value={values.emailaddress}
                        // onChange={handleChange('emailaddress')}
                        />
                        <div>
                            <Typography className={classes.bottomLine}>
                                {((apiResponse && apiResponse[12].relevanceResponseCRC) || relevenceDispay.emailaddressRelevance) ===
                                    'Relevant' ? (
                                        <div className={classes.relevanceIndicator}>
                                            {
                                                // (apiResponse && apiResponse[12].relevanceRemarksCRC) || relevenceDispay.emailaddressRelevanceRemarks}{' '}
                                                (apiResponse && apiResponse[12].relevanceRemarksCRC)}{' '}

                                        </div>
                                    ) : ((apiResponse && apiResponse[12].relevanceResponseCRC) || relevenceDispay.emailaddressRelevance) ===
                                        'Irrelavant' ? (
                                            <div className={classes.irrelevanceIndicator}>
                                                {
                                                    // (apiResponse && apiResponse[12].relevanceRemarksCRC) || relevenceDispay.emailaddressRelevanceRemarks}
                                                    (apiResponse && apiResponse[12].relevanceRemarksCRC)}

                                            </div>
                                        ) : ((apiResponse && apiResponse[12].relevanceResponseCRC) || relevenceDispay.emailaddressRelevance) ===
                                            'Paritially Relevant' ? (
                                                <div className={classes.partrelevanceIndicator}>
                                                    {
                                                        // (apiResponse && apiResponse[12].relevanceRemarksCRC) || relevenceDispay.emailaddressRelevanceRemarks}
                                                        (apiResponse && apiResponse[12].relevanceRemarksCRC)}

                                                </div>
                                            ) : (
                                                ''
                                            )}
                            </Typography>
                        </div>
                        {stageId === 10 && usertype === 'EM' ? (
                            ''
                        ) : stageId === 8 && apiResponse && apiResponse[12].relevanceResponseCRC === 'Relevant' ? (
                            ''
                        ) : (
                                    <Button
                                        // disabled={usertype === 'EM' ? 'disabled' : ''}
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        startIcon={<InsertCommentIcon />}
                                        onClick={() =>
                                            handleRelevence(
                                                'emailaddress',
                                                relevenceDispay.emailaddressRelevance || (apiResponse && apiResponse[12].relevanceResponseCRC),
                                                (apiResponse && apiResponse[12].relevanceRemarksCRC) || relevenceDispay.emailaddressRelevanceRemarks
                                            )
                                        }
                                        disabled={buttonDisable(stageId, userType.value)}
                                    >
                                        Add Relevance
                            </Button>
                                )}
                    </FormControl>
                </Grid>
                {apiResponse && apiResponse[0].response === "NaN" ? "" :
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth className={classes.margin}>
                            <InputLabel htmlFor="standard-adornment-amount">Passport Number</InputLabel>
                            <Input
                                disabled
                                className={classes.bottomLine}
                                id="standard-adornment-amount"
                                value={values.passport}
                            // onChange={handleChange('passportNumber')}
                            />
                            <div>
                                <Typography className={classes.bottomLine}>
                                    {((apiResponse && apiResponse[13].relevanceResponseCRC) || relevenceDispay.passportRelevance) ===
                                        'Relevant' ? (
                                            <div className={classes.relevanceIndicator}>
                                                {/* {(apiResponse && apiResponse[13].relevanceRemarksCRC) || relevenceDispay.passportRelevanceRemarks}{' '} */}
                                                {(apiResponse && apiResponse[13].relevanceRemarksCRC)}{' '}

                                            </div>
                                        ) : ((apiResponse && apiResponse[13].relevanceResponseCRC) || relevenceDispay.passportRelevance) ===
                                            'Irrelavant' ? (
                                                <div className={classes.irrelevanceIndicator}>
                                                    {/* {(apiResponse && apiResponse[13].relevanceRemarksCRC) || relevenceDispay.passportRelevanceRemarks} */}
                                                    {(apiResponse && apiResponse[13].relevanceRemarksCRC)}

                                                </div>
                                            ) : ((apiResponse && apiResponse[13].relevanceResponseCRC) || relevenceDispay.passportRelevance) ===
                                                'Paritially Relevant' ? (
                                                    <div className={classes.partrelevanceIndicator}>
                                                        {/* {(apiResponse && apiResponse[13].relevanceRemarksCRC) || relevenceDispay.passportRelevanceRemarks} */}
                                                        {(apiResponse && apiResponse[13].relevanceRemarksCRC)}

                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                </Typography>
                            </div>
                            {stageId === 10 && usertype === 'EM' ? (
                                ''
                            ) : stageId === 8 && apiResponse && apiResponse[13].relevanceResponseCRC === 'Relevant' ? (
                                ''
                            ) : (
                                        <Button
                                            // disabled={usertype === 'EM' ? 'disabled' : ''}
                                            variant="outlined"
                                            color="primary"
                                            size="small"
                                            className={classes.button}
                                            startIcon={<InsertCommentIcon />}
                                            onClick={() =>
                                                handleRelevence(
                                                    'passport',
                                                    relevenceDispay.passportRelevance || (apiResponse && apiResponse[13].relevanceResponseCRC),
                                                    (apiResponse && apiResponse[13].relevanceRemarksCRC) || relevenceDispay.passportRelevanceRemarks
                                                )
                                            }
                                            disabled={buttonDisable(stageId, userType.value) || (apiResponse && apiResponse[13].response === '')}
                                        >
                                            Add Relevance
                            </Button>
                                    )}
                        </FormControl>
                    </Grid>
                }
                {apiResponse && apiResponse[0].response === "NaN" ? "" :
                    <Grid item xs={12} sm={12}>
                        <FormControl fullWidth>
                            <Typography variant="subtitle1" gutterBottom>
                                Do you have Aadhaar number?
                        </Typography>
                            <div>
                                <FormControl component="fieldset">
                                    <RadioGroup
                                        value={values.govIDType}
                                        aria-label="aadhar"
                                        id="govIDType"
                                        name="govIDType"
                                        className="radio-option"
                                    >
                                        <ul className={classes.inlineDisplay}>
                                            <li>
                                                <FormControlLabel value="aadharNo" control={<StyledRadio />} label="Aadhaar number" disabled />
                                            </li>
                                            <li>
                                                <FormControlLabel
                                                    value="enrollmentNo"
                                                    control={<StyledRadio />}
                                                    label="Enrollment number"
                                                    disabled
                                                />
                                            </li>
                                            <li>
                                                <FormControlLabel value="notEnrolled" control={<StyledRadio />} label="Not Enrolled" disabled />
                                            </li>
                                        </ul>
                                    </RadioGroup>
                                </FormControl>
                                {values.govIDType !== 'notEnrolled' ? (
                                    <FormControl fullWidth>
                                        {/* <InputLabel htmlFor="aadhar-number">Aadhar Number</InputLabel> */}
                                        <Input
                                            disabled
                                            className={classes.bottomLine}
                                            id="standard-adornment-amount"
                                            value={values.govIDNumber}
                                        // onChange={handleChange()}
                                        />
                                        <div className={classes.btnFieldPositionRight}>
                                            {values.aadharFile ? (
                                                <span style={{ position: 'relative', bottom: '14px' }}>
                                                    <span style={{ marginRight: '7px' }}>
                                                        {values.aadharFile.substring(values.aadharFile.lastIndexOf('/') + 1).substring(0, 15)}
                                                        {values.aadharFile.substring(values.aadharFile.lastIndexOf('/') + 1).length > 15
                                                            ? '...'
                                                            : ''}
                                                    </span>
                                                    <span onClick={() => handlePreviewModal(values.aadharFile)}>
                                                        <Tooltip title="Preview">
                                                            <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                                        </Tooltip>
                                                    </span>
                                                    <span onClick={() => downloadCoreFile(values.aadharFile)}>
                                                        <Tooltip title="Download">
                                                            <img
                                                                src={downloadImage}
                                                                alt="downloadImage"
                                                                className="downlaodImg downloadImgTop"
                                                            />
                                                        </Tooltip>
                                                    </span>
                                                </span>
                                            ) : null}
                                        </div>
                                        <div>
                                            <Typography className={classes.bottomLine}>
                                                {(
                                                    (apiResponse && apiResponse[15].relevanceResponseCRC) || relevenceDispay.govIDNumberRelevance) === 'Relevant' ? (
                                                        <div className={classes.relevanceIndicator}>
                                                            {
                                                                // (apiResponse && apiResponse[15].relevanceRemarksCRC) || relevenceDispay.govIDNumberRelevanceRemarks}
                                                                (apiResponse && apiResponse[15].relevanceRemarksCRC)}

                                                        </div>
                                                    ) : (
                                                        (apiResponse && apiResponse[15].relevanceResponseCRC) || relevenceDispay.govIDNumberRelevance) === 'Irrelavant' ? (
                                                            <div className={classes.irrelevanceIndicator}>
                                                                {
                                                                    // (apiResponse && apiResponse[15].relevanceRemarksCRC) || relevenceDispay.govIDNumberRelevanceRemarks}
                                                                    (apiResponse && apiResponse[15].relevanceRemarksCRC)}

                                                            </div>
                                                        ) : (
                                                            (apiResponse && apiResponse[15].relevanceResponseCRC) || relevenceDispay.govIDNumberRelevance) === 'Paritially Relevant' ? (
                                                                <div className={classes.partrelevanceIndicator}>
                                                                    {
                                                                        // (apiResponse && apiResponse[15].relevanceRemarksCRC) || relevenceDispay.govIDNumberRelevanceRemarks}
                                                                        (apiResponse && apiResponse[15].relevanceRemarksCRC)}

                                                                </div>
                                                            ) : (
                                                                ''
                                                            )}
                                            </Typography>
                                        </div>
                                        {stageId === 10 && usertype === 'EM' ? (
                                            ''
                                        ) : stageId === 8 && apiResponse && apiResponse[15].relevanceResponseCRC === 'Relevant' ? (
                                            ''
                                        ) : (
                                                    <Button
                                                        // disabled={usertype === 'EM' ? 'disabled' : ''}
                                                        variant="outlined"
                                                        color="primary"
                                                        size="small"
                                                        className={classes.button}
                                                        startIcon={<InsertCommentIcon />}
                                                        onClick={() =>
                                                            handleRelevence(
                                                                'govIDNumber',
                                                                relevenceDispay.govIDNumberRelevance ||
                                                                (apiResponse && apiResponse[15].relevanceResponseCRC),
                                                                (apiResponse && apiResponse[15].relevanceRemarksCRC) ||
                                                                relevenceDispay.govIDNumberRelevanceRemarks
                                                            )
                                                        }
                                                        disabled={buttonDisable(stageId, userType.value)}
                                                    >
                                                        Add Relevance
                                        </Button>
                                                )}
                                    </FormControl>
                                ) : (
                                        ''
                                        // <div> Hello </div>
                                    )}
                            </div>
                        </FormControl>
                    </Grid>
                }
                <Grid item xs={12} sm={12}>
                    <FormControl fullWidth>
                        <Typography variant="subtitle1" gutterBottom>
                            Have you registered under GST?
                        </Typography>
                        <div>
                            <FormControl component="fieldset">
                                <RadioGroup aria-label="yes-no" name="radiodata" className="radio-option" value={values.radiodata}>
                                    <ul className={classes.inlineDisplay}>
                                        <li>
                                            <FormControlLabel
                                                // value="Yes"
                                                value="Yes"
                                                control={<StyledRadio />}
                                                label="Yes"
                                                disabled
                                            />
                                        </li>
                                        <li>
                                            <FormControlLabel
                                                //  value="No"
                                                value="No"
                                                control={<StyledRadio />}
                                                label="No"
                                                disabled
                                            />
                                        </li>
                                    </ul>
                                </RadioGroup>
                            </FormControl>
                            {values.radiodata === 'Yes' ? (
                                <FormControl fullWidth>
                                    <Input
                                        disabled
                                        className={classes.bottomLine}
                                        id="GSTIN"
                                        name="GSTIN"
                                        value={values.GSTIN}
                                    // onChange={handleChange('GSTIN')}
                                    />
                                    <div className={classes.btnFieldPositionRight}>
                                        {values.gstFile ? (
                                            <span style={{ position: 'relative', bottom: '14px' }}>
                                                <span style={{ marginRight: '7px' }}>
                                                    {values.gstFile.substring(values.gstFile.lastIndexOf('/') + 1).substring(0, 15)}
                                                    {values.gstFile.substring(values.gstFile.lastIndexOf('/') + 1).length > 15 ? '...' : ''}
                                                </span>
                                                <span onClick={() => handlePreviewModal(values.gstFile)}>
                                                    <Tooltip title="Preview">
                                                        <img src={PreviewImage} alt="PreviewImage" className="fileView" />
                                                    </Tooltip>
                                                </span>
                                                <span onClick={() => downloadCoreFile(values.gstFile)}>
                                                    <Tooltip title="Download">
                                                        <img
                                                            src={downloadImage}
                                                            alt="downloadImage"
                                                            className="downlaodImg downloadImgTop"
                                                        />
                                                    </Tooltip>
                                                </span>
                                            </span>
                                        ) : null}
                                    </div>
                                    <div>
                                        <Typography className={classes.bottomLine}>
                                            {((apiResponse && apiResponse[18].relevanceResponseCRC) || relevenceDispay.gstinRelevance) ===
                                                'Relevant' ? (
                                                    <div className={classes.relevanceIndicator}>
                                                        {
                                                            // (apiResponse && apiResponse[18].relevanceRemarksCRC) || relevenceDispay.gstinRelevanceRemarks}{' '}
                                                            (apiResponse && apiResponse[18].relevanceRemarksCRC)}{' '}

                                                    </div>
                                                ) : (
                                                    (apiResponse && apiResponse[18].relevanceResponseCRC) || relevenceDispay.gstinRelevance) === 'Irrelavant' ? (
                                                        <div className={classes.irrelevanceIndicator}>
                                                            {
                                                                // (apiResponse && apiResponse[18].relevanceRemarksCRC) || relevenceDispay.gstinRelevanceRemarks}
                                                                (apiResponse && apiResponse[18].relevanceRemarksCRC)}

                                                        </div>
                                                    ) : (
                                                        (apiResponse && apiResponse[18].relevanceResponseCRC) || relevenceDispay.gstinRelevance) === 'Paritially Relevant' ? (
                                                            <div className={classes.partrelevanceIndicator}>
                                                                {
                                                                    // (apiResponse && apiResponse[18].relevanceRemarksCRC) || relevenceDispay.gstinRelevanceRemarks}
                                                                    (apiResponse && apiResponse[18].relevanceRemarksCRC)}

                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                        </Typography>
                                    </div>
                                    {stageId === 10 && usertype === 'EM' ? (
                                        ''
                                    ) : stageId === 8 && apiResponse && apiResponse[18].relevanceResponseCRC === 'Relevant' ? (
                                        ''
                                    ) : (
                                                <Button
                                                    // disabled={usertype === 'EM' ? 'disabled' : ''}
                                                    // disabled={stageId === 8 && apiResponse && apiResponse[18].relevanceResponseCRC === 'Relevant'}
                                                    variant="outlined"
                                                    color="primary"
                                                    size="small"
                                                    className={classes.button}
                                                    startIcon={<InsertCommentIcon />}
                                                    onClick={() =>
                                                        handleRelevence(
                                                            'GSTIN',
                                                            relevenceDispay.GSTINRelevance || (apiResponse && apiResponse[18].relevanceResponseCRC),
                                                            (apiResponse && apiResponse[18].relevanceRemarksCRC) ||
                                                            relevenceDispay.GSTINRelevanceRemarks
                                                        )
                                                    }
                                                    disabled={buttonDisable(stageId, userType.value)}
                                                >
                                                    Add Relevance
                                        </Button>
                                            )}
                                </FormControl>
                            ) : null}
                        </div>
                    </FormControl>
                </Grid>
                <PreviewModal fileSource={downloadFile} visibleClose={visible} handleModalClose={handleModalClose} />
                {showBtnLoader ? <LoaderPopUp showLoader={showBtnLoader} handleClose={handleClose} title="" /> : null}
            </Grid>
            {itecOpen && (
                <CrcDialog
                    itecOpen={itecOpen}
                    crcCategory={category}
                    crcRemarks={remarks}
                    updateCRCRelevance={updateCRCRelevance}
                    handleItecClose={handleItecClose}
                />
            )}
            {/* {
                itecOpen && relevanceCat === "lastname" && <CrcDialog itecOpen={itecOpen} crcCategory={lastnamecategory} crcRemarks={lastremarks} updateCRCRelevance={updateCRCRelevance} handleItecClose={handleItecClose} />
            } */}
        </>
    );
}
